import React, { Component, Fragment } from "react";

import { API_URL } from "../../config";
import { Button } from "react-admin";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import { getToken } from "../../authBody";

class ExportIpsButton extends Component {
  handleClick = () => {
    const { filter } = this.props;
    const token = getToken();
    window.open(
      `${API_URL}/device/exportIps/${token}/doc.pdf?filter=${JSON.stringify(
        filter
      )}`,
      "_blank"
    );
  };

  render() {
    return (
      <Fragment>
        <Button
          label={"resources.device.buttons.print_ips"}
          onClick={this.handleClick}
        >
          <PictureAsPdfIcon />
        </Button>
      </Fragment>
    );
  }
}
export default ExportIpsButton;
